"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_1 = require("@ethersproject/bignumber");
const base_1 = require("../base");
const util_1 = require("../util");
class ERC20Module extends base_1.TectonicSDKModule {
    async balanceOf(tokenContractAddress, ownerAddress) {
        const erc20Contract = this.getContractByAddress(tokenContractAddress);
        return erc20Contract.balanceOf(ownerAddress);
    }
    async approve(tokenContractAddress, spenderAddress, allowance) {
        const erc20Contract = this.getContractByAddress(tokenContractAddress);
        return (0, util_1.wrapPlainTransaction)(erc20Contract.approve(spenderAddress, bignumber_1.BigNumber.from(allowance)));
    }
    async transfer(tokenContractAddress, toAddress, amount) {
        const erc20Contract = this.getContractByAddress(tokenContractAddress);
        return (0, util_1.wrapPlainTransaction)(erc20Contract.transfer(toAddress, bignumber_1.BigNumber.from(amount)));
    }
    async allowanceOf(tokenContractAddress, ownerAddress, spenderAddress) {
        const erc20Contract = this.getContractByAddress(tokenContractAddress);
        return erc20Contract.allowance(ownerAddress, spenderAddress);
    }
    async totalSupply(tokenContractAddress) {
        const erc20Contract = this.getContractByAddress(tokenContractAddress);
        return erc20Contract.totalSupply();
    }
}
exports.default = ERC20Module;
//# sourceMappingURL=erc20.js.map